import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { directDebitCommand } from '../../command/direct-debit';
import { DirectDebitExportCommandHandler } from './direct-debit-export-command-handler.service';
import { OpenInvoiceFromDirectDebitCommandHandler } from './open-invoice-from-directdebit-command-handler.service';

@Injectable()
export class DirectDebitCommandHandlerResolver extends CommandHandlerResolver {
  constructor(exportHandler: DirectDebitExportCommandHandler, openInvoiceHandler: OpenInvoiceFromDirectDebitCommandHandler) {
    super();
    this.addHandler(directDebitCommand.export, exportHandler);
    this.addHandler(directDebitCommand.openInvoice, openInvoiceHandler);
  }
}
